<template>
    <div class="wrapper" v-if="load">
        <div class="title">定制你的专属形象</div>
        <div class="tips">左右滑动选择造型</div>
        <div class="mouldingBox" v-if="list.length>0">
            <swiper :options="mySwiperOption">
                <swiper-slide v-for="(item, index) in list" :key="index" :data-index="index">
                    <div class="imgBox">
                        <img :src="item.url" alt="">
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div class="placard" @click="selectTag"></div>
    </div>
</template>

<script>
import { swiper, swiperSlide  } from 'vue-awesome-swiper'
import { editCard,editReport } from '@/api'
export default {
    components: {
        swiper,
        swiperSlide,
    },
    props: {},
    data() {
        return {
            load:false,
            sex:0,
            sexList:[{
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/girl1.png',
                sex:2,
                id:1
            },{
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/male1.png',
                sex:1,
                id:2
            },{
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/girl2.png',
                sex:2,
                id:3
            },{
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/male2.png',
                sex:1,
                id:4
            },{
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/girl3.png',
                sex:2,
                id:5
            },{
                url:'https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/male3.png',
                sex:1,
                id:6
            },],
            mySwiperOption: {

                loop: true,
                on: {
                    slideChangeTransitionStart: function () {
                        console.log("change有在变")
                        window.index = this.realIndex
                    }
                }


            },
            userInfo:{},
            tagModel:{},
            //type类型1判断大小2检索字符3判断真假4判断字符是否为空5判断区间
            tagList:[{
                tagName:'鹭岛\n常驻民',
                signature:'每个不平凡的日子，都有i相伴',
                conditions:20230101,
                sectionMin:'',
                sectionMax:'',
                type:1,
                key:'registDate'
            },{
                tagName:'鹭岛\n新居民',
                signature:'保持那一份热爱，奔赴下一场山海',
                conditions:20230101,
                sectionMin:'',
                sectionMax:'',
                type:1,
                key:'registDate'
            },{
                tagName:'白天\n冲浪家',
                signature:'追光而遇，沐光而行',
                conditions:'上午/下午',
                sectionMin:'',
                sectionMax:'',
                type:2,
                key:'mostLoginPeriod'

            },{
                tagName:'被窝\n冲浪家',
                signature:'岁月欢喜一步步，成就人间朝与暮',
                conditions:'夜晚/凌晨',
                sectionMin:'',
                sectionMax:'',
                type:2,
                key:'mostLoginPeriod'
            },{
                tagName:'鹭岛\n探险家',
                signature:'感受人生的每一种可能',
                conditions:'',
                sectionMin:'',
                sectionMax:'',
                type:3,
                key:'isNewUser'
            },{
                tagName:'一级\n潜水专家',
                signature:'潜力无限，未来可期',
                conditions:'',
                sectionMin:'',
                sectionMax:'',
                type:3,
                key:'isNewUser'
            },{
                tagName:'幸福\n守护者',
                signature:'灯火阑珊的温暖，柴米油盐的充实',
                conditions:'',
                sectionMin:'',
                sectionMax:'',
                type:4,
                key:'livingVisitDate'
            },{
                tagName:'佛系\n辅导员',
                signature:'不写作业母慈子孝，一写作业鸡飞狗跳',
                conditions:'',
                sectionMin:'',
                sectionMax:'',
                type:4,
                key:'ieduFirstVisit'
            },{
                tagName:'智慧生活\n导航员',
                signature:'美好生活，跃然“指”上',
                conditions:'',
                sectionMin:'',
                sectionMax:'',
                type:4,
                key:'waterGasCnt'
            },{
                tagName:'斜杠\n青年',
                signature:'多样人生，无限可能',
                conditions:'',
                sectionMin:16,
                sectionMax:30,
                type:5,
                key:'age'
            },{
                tagName:'稳重\n肖年家',
                signature:'无论他人“供虾米”，心中自有衡量的标准',
                conditions:'',
                sectionMin:31,
                sectionMax:44,
                type:5,
                key:'age'
            },{
                tagName:'六边形\n战士',
                signature:'流水不争先，争的是滔滔不绝',
                conditions:'',
                sectionMin:45,
                sectionMax:59,
                type:5,
                key:'age'
            },{
                tagName:'养生\n达人',
                signature:'从未停止炽热的脚步',
                conditions:'',
                sectionMin:60,
                sectionMax:200,
                type:5,
                key:'age'
            },]
        }
    },
    watch: {},
    computed: {
        list(){
            let list = []
            if(this.sex == 3){
                list = this.sexList
            }else{
                list = this.sexList.filter(item=>{
                    return item.sex == this.sex
                })
            }
            return list
        }
    },
    methods: {
        editCard(){
            editCard({
                manualTag:this.tagModel.tagName,
                percent:Math.floor(Math.random()*3) + 1 + '0',
                roleNumber:this.list[window.index].id,
                goldenSentence:this.tagModel.signature
            }).then(res=>{
                this.$jump('/callingCard')

            })
        },
        editReport(){
            editReport().then(res=>{
                this.$jump('/callingCard')
            })
        },
        selectTag(){
            // let list = Object.keys(this.userInfo)
            let tagList = []
            this.tagList.forEach((ele,index) => {
                if(ele.type == 1 && index == 0){
                    if(this.userInfo[ele.key]>ele.conditions){
                        tagList.push({...ele}) 
                    } 
                }else if(ele.type == 1 && index == 1){
                    if(this.userInfo[ele.key]<=ele.conditions){
                        tagList.push({...ele}) 
                    } 
                }
                if(ele.type == 2){
                    if(ele.conditions.indexOf(this.userInfo[ele.key])!=-1){
                        tagList.push({...ele})
                    }
                }
                if(ele.type == 3){
                    if(this.userInfo[ele.key] == 0 && index == 4){
                        tagList.push({...ele})
                    }
                    if(this.userInfo[ele.key] == 1 && index == 5){
                        tagList.push({...ele})
                    }
                }
                if(ele.type == 4){
                    if(this.userInfo[ele.key]){
                        tagList.push({...ele})
                    }
                }
                if(ele.type == 5){
                    if(this.userInfo[ele.key]>ele.sectionMin&&this.userInfo[ele.key]<=ele.sectionMax){
                        tagList.push({...ele})
                    }
                }

            });
            let numIndex = Math.floor(Math.random()*tagList.length)
            // console.log(tagList[numIndex])
            this.tagModel = tagList[numIndex]
            this.editCard()

        }

    },
    created() { 
       
        
    },
    mounted() { 
        this.userInfo = JSON.parse(sessionStorage.getItem('report')) 
        this.sex = this.userInfo.gender 
        setTimeout(()=>{
            this.load = true

        },500)
    }
}
</script>
<style scoped lang="scss">
.wrapper {
    width: 100vw;
    height: 100vh;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/imageCustomizationBg.png);
    background-position: top;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.title{
    width: 100%;
    height: .84rem;
    font-size: .7rem;
    line-height: .84rem;
    color: #fff;
    font-family: DingTalkJinBuTi;
    text-align: center;
    margin-top: 1.14rem;

}
.tips{
    width: 100%;
    height: .51rem;
    font-size: .42rem;
    line-height: .51rem;
    color: #fff;
    font-family: DingTalkJinBuTi;
    text-align: center;
    margin-top: .23rem;
}
.mouldingBox{
    width: 100vw;
    height: calc(100vh - 6rem);
    margin-top: .8rem;
    
    .imgBox{
        height: calc(100vh - 6rem);
        width: 4.29rem;
        margin:  0 auto;
        display: flex;
        justify-content: center;
        align-items: center;

        img{
            max-height: 100%;
            width: auto;
        }
    }
}
.placard{
    width: 5.46rem;
    height: 1.89rem;
    background-size: 100% auto;
    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/ic-bt.png);
    margin-top: .6rem
}
.swiper-container{
   overflow: hidden;
}

.swiper-slide{
    transition: all .5s;

}
.swiper-slide-prev {
    right: -4rem;
    opacity: 0.5;
    transform: scale(0.83);


    .name {
        display: none;
    }
}

.swiper-slide-next {
    left: -4rem;
    transform: scale(0.83);
    opacity: 0.5;

    .name {
        display: none;
    }
}
</style>